/* eslint-disable no-useless-escape */
import axios from "axios";

import { env } from "./env";

export default class BaseService {
  protected static readonly url = env.webApiBaseUrl;

  protected static async get(
    endpoint: string,
    queryString?: string,
    body?: string,
  ) {
    try {
      let url = `${this.url}${endpoint}`;
      if (queryString) {
        url += `?${queryString}`;
      }

      const result = await axios({
        url,
        method: "GET",
        data: body,
      });

      return result;
    } catch (e) {
      const err = e as any;
      console.error("API Error", err?.response);

      if (err?.response?.status === 0 || err?.response?.status === 401) {
        throw new Error("Permissions denied");
      }

      if (err?.response?.data?.errorMessage) {
        throw new Error(err?.response?.data?.errorMessage);
      }

      throw e;
    }
  }

  protected static async proxy(
    cypherName: string,
    params: { [key: string]: any },
    page: number,
    pageSize: number,
  ): Promise<any[]> {
    const paramString = Object.keys(params)
      .map((key) => {
        if (
          (key === "party" || key === "destination") &&
          (params[key] === null || params[key] === undefined)
        ) {
          return `&${key}=`;
        }
        if (params[key] === null || params[key] === undefined) {
          return "";
        }

        if (Array.isArray(params[key])) {
          if (params[key].length === 0) {
            return "";
          }

          return `&${key}=${JSON.stringify(params[key])}`;
        }

        return `&${key}=${params[key]}`;
      })
      .join("")
      .replace(/\|/g, "%7C")
      .replace(/\#/g, "%23");

    const response: any = await this.get(
      `/proxy/${cypherName}`,
      `skip=${(page - 1) * pageSize}&limit=${pageSize}${paramString}`,
      JSON.stringify({ params: JSON.stringify(params) }),
    );

    return response?.data || [];
  }
}
